module.exports = __webpack_public_path__ + "static/img/2.fdd6313.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/zh/2.png
// module id = m/gz
// module chunks = 0